<template>
<!-- 其他推荐 -->
    <div class="main">
        <div class="title" style="margin-bottom:20px">其他推荐</div>
        <div class="list-model" v-if="dataL.length>0">
            <div class="list-item-model" v-for="(item , index) in dataL.slice(0,6)" :key="index" @click="toDetail(item.id)">
                <div class="item-img">
                    <img class="cover coverImg" :src="item.coverImg" alt="">
                    <img class="play-icon" src="icon/learnIcon/choiceness-play.svg" alt="">
                </div>
                <div class="item-content">
                    <div class="item-title">{{item.title}}</div>
                    <div class="item-name">作者：{{item.author}}</div>
                    <div class="item-count">{{item.playCount || 0}}次播放</div>
                </div>
            </div>
            <div class="model" v-for="i in 2">
                <div v-if="dataL[i*6]" class="list-item-ad">
                    <div class="ad-card">
                        <div class="ad-img">
                            <img class="cover" :src="dataL[i*6].coverImg" alt="">
                        </div>
                        <div class="ad-content">
                            <h3>{{dataL[i*6].title}}</h3>
                            <div class="ad-parameter">
                                <span class="par-margin">作者：{{dataL[i*6].author}}</span>
                                <span>{{dataL[i*6].playCount || 0}}次播放</span>
                            </div>
                            <div @click="toDetail(dataL[i*6].id)"  class="go-learn">
                                <img src="icon/learnIcon/golearn-play.svg" alt="">
                                <span>去学习</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-item-model" v-for="(item , index) in dataL.slice(i*6,6)" :key="index" @click="toDetail(item.id)">
                    <div class="item-img">
                        <img class="cover coverImg" :src="item.coverImg" alt="">
                        <img class="play-icon" src="icon/learnIcon/choiceness-play.svg" alt="">
                    </div>
                    <div class="item-content">
                        <div class="item-title">{{item.title}}</div>
                        <div class="item-name">作者：{{item.author}}</div>
                        <div class="item-count">{{item.playCount || 0}}次播放</div>
                    </div>
                </div>

            </div>


        </div>
        <div class="content_tip" v-else>
             <div>
                    该分类下暂无内容哦
                </div>
        </div>
    </div>
</template>
<script>

// part
// import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// platformApi
import requestManager from '@comp/platformApi/requestManager';

// const config = {
//     apiConfig : {
//         list : {
//             url : 'portal/api/audio',
//             params:{
//                 type:2
//             },
//             dataPath : 'data.records',
//             totalPath : 'data.total',
//             totalPagePath : 'data.pages'
//         }
//     }
// };



export default {
      name: "choicenessMore",
    // extends : shixunPagePart,
    props:['classifyItem'],

    data(){
        return {
            // enableDataList : true,
            // autoLoadDataList : true,
            // // scrollToLoadNextPage:false,
            // apiConfig : config.apiConfig,

             getData:{},
            qData:{},
            dataL:[],

        }
    },
     watch:{
        classifyItem:{
            handler(newItem , oldItem) {
                this.getData1();
                },
                deep: true
        },
    },
    methods:{
         toDetail(id){
            this.$router.push({name:'albumID',params: {id:id}})
        },
         getData1(){
            if(this.classifyItem){
                let item = this.classifyItem
                let qData = {}
                qData.categoryFirst = item.id
                // qData.categorySecond = item.pid
                // qData.title = item.name
                qData.type = 2
                if(qData.categoryFirst){

                    requestManager.request({
                        url : 'portal/api/audio',
                        params : qData || {}
                    }, (error, result) => {
                        if (error)
                        {
                            return;
                        }
                        this.dataL = result.data.records || [];
                    });

                }
            }
        }

    },
    mounted(){
        this.getData1();

    }
}
</script>
<style lang="scss" scoped>
.content_tip{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
}





.main{
    width: 90%;
    height: 100%;
    margin: 0 auto;
}

.title{

    font-size: 18px;

    font-weight: 600;
    color: #484C5E;

}
.list-model{

}

.list-item-model{
    width: 100%;
    height: 84px;
    margin-bottom: 24px;
    display: flex;
}

.item-img{
    position: relative;
    width: 84px;
    height: 84px;
    border-radius: 6px;
    .coverImg{
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }
    .play-icon{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 26px;
        height: 26px;

    }
}


.item-content{
    position: relative;
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    .item-title{
        position: absolute;
        top: 12px;
        left: 12px;

        font-size: 14px;

        font-weight: 600;
        color: #333333;

    }
    .item-name{
        position: absolute;
        left: 12px;
        bottom: 12px;

        font-size: 12px;

        font-weight: 400;
        color: #333333;

    }
    .item-count{
        position: absolute;
        right: 0;
        bottom: 12px;

        font-size: 12px;

        font-weight: 400;
        color: #999999;

    }

}


.list-item-ad{
    height: 187px;
    background: #F6F6F6;

    border-radius: 8px;
    margin-bottom: 24px;
}


 .ad-card{
            width: 100%;
            height: 187px;
            background: #F6F6F6;

            border-radius: 8px;
            .ad-img{
                width: 100%;
                height: 121px;
                background: rgba(0, 0, 0, 0);

                border-radius: 8px;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 8px;
                }
            }
            .ad-content{
                position: relative;
                width: 94%;
                height: 66px;
                margin: 0 auto;
                h3{
                    margin: 0;

                    padding-top: 8px;
                    height: 22px;
                    font-size: 16px;

                    font-weight: 600;
                    line-height: 22px;
                    color: #333333;

                }

                .ad-parameter{
                    padding-top: 8px;
                    height: 17px;
                    font-size: 12px;

                    font-weight: 400;
                    line-height: 17px;
                    color: #999999;

                    .par-margin{
                        margin-right: 24px;
                    }
                }


                .go-learn{
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    padding: 0 20px;
                    height: 34px;
                    line-height: 34px;
                    background: linear-gradient(159deg, #FE7247 0%, #FF3E5B 100%);

                    border-radius: 17px;
                    box-shadow: 4px 4px 10px #ffc3cb;
                    img{
                        width: 11px;
                        height: 16px;
                        vertical-align:middle;
                        margin-right: 6px;
                    }
                    span{

                        font-size: 14px;

                        font-weight: 400;
                        color: #FFFFFF;

                    }
                }
            }


        }
</style>
